import { useEffect, useState } from 'react';
import { Textfield } from '@simplywallst/ui-core';

import { validateTargetSharePrice } from '../../utils/validator';
import { FieldWrapper, StyledForm } from './styled';

enum FormFieldName {
  targetSharePrice = 'targetSharePrice',
}

interface FormFields {
  [FormFieldName.targetSharePrice]: string;
}

export interface NoteReminderPriceFormProps {
  onChange: (updatedFormFields: FormFields) => void;
  targetSharePrice?: number;
  currentSharePrice?: number;
}

const NoteReminderPriceForm = ({
  onChange,
  targetSharePrice,
  currentSharePrice,
}: NoteReminderPriceFormProps) => {
  const [formFields, setFormFields] = useState<FormFields>({
    targetSharePrice:
      typeof targetSharePrice !== 'undefined'
        ? targetSharePrice.toFixed(2)
        : '',
  });

  useEffect(() => {
    if (typeof targetSharePrice !== 'undefined') {
      setFormFields({
        ...formFields,
        targetSharePrice: targetSharePrice.toFixed(2),
      });
      onChange({
        ...formFields,
        targetSharePrice: targetSharePrice.toFixed(2),
      });
    } else {
      setFormFields({ targetSharePrice: '' });
    }
  }, [targetSharePrice]);

  const handleOnChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    setFormFields({ ...formFields, [name]: value });
    onChange({ ...formFields, [name]: value });
  };

  const handleOnSubmit = (event) => {
    event.preventDefault();
  };

  const error =
    formFields[FormFieldName.targetSharePrice] === '' ||
    validateTargetSharePrice(
      formFields[FormFieldName.targetSharePrice],
      currentSharePrice
    )
      ? undefined
      : 'Please enter a valid target share price';

  return (
    <StyledForm onSubmit={handleOnSubmit}>
      <FieldWrapper>
        <Textfield
          styleType="standard"
          type="text"
          placeholder="Enter a target share price to get notified"
          autoComplete="off"
          name={FormFieldName.targetSharePrice}
          value={formFields[FormFieldName.targetSharePrice]}
          onChange={handleOnChange}
          error={error}
        />
      </FieldWrapper>
    </StyledForm>
  );
};

export default NoteReminderPriceForm;
